export const OTP_VALIDATE = {
    HEADING: 'Two-Factor Authentication',
    TEXT: (email: string) => `Your account is protected with two-factor authentication. We’ve sent you an OTP at ${email}.`,
    SUB_TEXT: 'Please enter the code below.',
    VALIDATE_BUTTON: 'Validate',
    RESEND_BUTTON: 'Resend OTP',
    PLACEHOLDER: 'Enter OTP of 4 digits',
}
